<template>
  <div class="no-auth">
    <Error
      :title="$t('com_error_forbidden')"
      :description="$t('com_error_forbidden_description')"
      style="margin-top:0;"
      homePrimary="primary"
      :homeClick="homeClick"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <Icon type="forbidden" />
    </Error>
  </div>
</template>
<script>
import Error from '@/components/Error';
export default {
  components: {
    Error,
  },
  created() {
    this.$store.commit('setPageLoading', false);
  },
  methods: {
    homeClick() {
      this.$router.replace({ name: 'Home' });
    },
  },
};
</script>
<style lang="less" scoped>
.no-auth {
  margin: 0 auto;
  color: #999;
  text-align: center;
  padding: 100px 0 0;
  svg {
    color: #ccc;
    margin-bottom: 15px;
  }
  p {
    padding: 0;
    line-height: 24px;
    margin: 0;
  }
}
</style>
